import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axios";
import CryptoJS from "crypto-js";
let secretKey = process.env.REACT_APP_SECRET_KEY;

// Function to encrypt data
const encryptData = (data, secretKey) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
};

const initialState = {
  userDetail: {},
  socialData: "",
  loginDetail: {},
  loginStatus: "loading",
  signupDetail: {},
  signupStatus: "loading",
  forgetpwDetail: {},
  forgetpwEmail: "",
  forgetpwStatus: "loading",
  verifyDetail: {},
  verifyStatus: "loading",
  resetDetail: {},
  resetStatus: "loading",
  signupEmail: "",
  loginId: "",
  earning: "",
  deleteStatus: {},
  withdraw: {},
  gpsPayment: "",
  withdrawRequest: "",
  editProfile: {},
  resentOtpResp: {},
};


const config = {
  headers: {
    key: "KwachaRides-api-secret-key",
  },
};

export const Login = createAsyncThunk("login", async (user) => {
  try {
    const response = await axios.post("/signupuser/login", user, config);
    // Encrypt the data
    const encryptedData = encryptData(response?.data, secretKey);
    localStorage.setItem("loginDetail", JSON.stringify(encryptedData));

    return response.data;
  } catch (error) {
    return error.response.data.errors;
  }
});

export const Signup = createAsyncThunk("signup", async (user) => {
  try {
    const response = await axios.post("/signupuser/signup", user, config);

    return response.data;
  } catch (error) {
    return error.response.data.errors;
  }
});

export const forgetPassword = createAsyncThunk(
  "forgetPassword",
  async (data) => {
    try {
      const response = await axios.post(
        "/signupuser/forgotPassword",
        data,
        config
      );

      return response?.data;
    } catch (error) {
      return error?.response?.data.errors;
    }
  }
);

export const verifyOTP = createAsyncThunk("verifyOTP", async (data) => {
  try {
    const response = await axios.post("/signupuser/verifyOtp", data, config);

    return response?.data;
  } catch (error) {
    return error?.response?.data.errors;
  }
});

export const resendOTP = createAsyncThunk("resendOTP", async (data) => {
  try {
    const response = await axios.post("/signupuser/resendOtp", data, config);

    return response?.data;
  } catch (error) {
    return error?.response?.data.errors;
  }
});

export const resetPassword = createAsyncThunk("resetPassword", async (data) => {
  try {
    const response = await axios.post(
      "/signupuser/resetPassword",
      data,
      config
    );

    return response?.data;
  } catch (error) {
    return error?.response?.data.errors;
  }
});

export const EditUserProfile = createAsyncThunk(
  "EditUserProfile",
  async (info) => {
    try {
      const response = await axios.put(
        `/signupuser/editProfile/${info?.id}`,
        info?.data,
        config
      );
      return response.data;
    } catch (error) {
      return error.response.data.errors;
    }
  }
);

export const getUserDetail = createAsyncThunk("getUserDetail", async (ID) => {
  const data = {
    userId: `${ID}`,
  };
  try {
    const response = await axios.post("/signupuser/getauser", data);

    return response.data;
  } catch (error) {
    return error.response.data.errors;
  }
});

export const deletemyaccount = createAsyncThunk(
  "deletemyaccount",
  async (info) => {
    const data = {
      userId: `${info?.userId}`,
    };
    try {
      const response = await axios.post(
        "/signupuser/deletemyaccount",
        data,
        config
      );
      return response.data;
    } catch (error) {
      return error.response.data.errors;
    }
  }
);

export const getEarning = createAsyncThunk("getEarning", async (ID) => {
  const data = {
    userId: `${ID}`,
  };
  try {
    const response = await axios.post(
      "/signupuser/getUserEarning",
      data,
      config
    );
    return response.data;
  } catch (error) {
    return error.response.data.errors;
  }
});

export const fetchWithdrawls = createAsyncThunk(
  "fetchWithdrawls",
  async (id) => {
    const data = {
      userId: `${id}`,
    };
    try {
      const response = await axios.post(
        "/signupuser/fetchWithdrawls",
        data,
        config
      );
      return response.data;
    } catch (error) {
      return error.response.data.errors;
    }
  }
);

export const bankWithdraw = createAsyncThunk("bankWithdraw", async (data) => {
  try {
    const response = await axios.post("/signupuser/withdraw", data, config);
    return response.data;
  } catch (error) {
    return error.response.data.errors;
  }
});
export const getGpsPayment = createAsyncThunk("getGpsPayment", async () => {
  try {
    const response = await axios.get("adminsetting/getGpsPayment");
    return response.data;
  } catch (error) {
    return error.response.data.errors;
  }
});

const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    Logout(state) {
      state.loginDetail = {};
      state.signupDetail = {};
      state.userDetail = {};
      state.forgetpwDetail = {};
      state.resetDetail = {};
      state.verifyDetail = {};
      state.signupEmail = "";
      state.loginId = "";
      state.gpsPayment = "";
      state.forgetpwEmail = "";
      localStorage.removeItem("loginDetail");
    },
    cleanUp(state) {
      state.signupDetail = {};
    },
    storeLoginId(state, action) {
      state.loginId = action.payload;
    },
    storeEmail(state, action) {
      state.signupEmail = action.payload;
    },
    storeFPmail(state, action) {
      state.forgetpwEmail = action.payload;
    },
    storeSocialData(state, action) {
      state.loginId = action?.payload?.data?._id;
    },
    cleanLogin(state) {
      state.loginDetail = {};
    },
    cleanupOtp(state) {
      state.verifyDetail = {};
    },
    cleanupLoginNotif(state) {
      state.loginStatus = "loading";
    },
    cleanupSignupNotif(state) {
      state.signupStatus = "loading";
    },
    cleanupVerifyNotif(state) {
      state.verifyStatus = "loading";
    },
    cleanupreset(state) {
      state.resetDetail = {};
    },
    cleanFPdetail(state) {
      state.forgetpwDetail = {};
    },
    cleanwithdraw: (state) => {
      state.withdraw = {};
    },
    clearEditProfile: (state) => {
      state.editProfile = {};
    },
    cleanResentOtp: (state) => {
      state.resentOtpResp = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(Login.pending, (state, action) => {
        state.loginStatus = "pending";
      })
      .addCase(Login.fulfilled, (state, action) => {
        state.loginDetail = action.payload;
        state.loginStatus = "fulfilled";
      })
      .addCase(Login.rejected, (state, action) => {
        state.loginStatus = "loading";
      })
      .addCase(Signup.fulfilled, (state, action) => {
        state.signupDetail = action.payload;
        state.signupStatus = "fulfilled";
      })
      .addCase(Signup.rejected, (state, action) => {
        state.signupStatus = "loading";
      })
      .addCase(Signup.pending, (state, action) => {
        state.signupStatus = "pending";
      })
      .addCase(EditUserProfile.fulfilled, (state, action) => {
        state.editProfile = action.payload;
      })
      .addCase(getUserDetail.fulfilled, (state, action) => {
        state.userDetail = action.payload;
      })
      .addCase(deletemyaccount.fulfilled, (state, action) => {
        state.deleteStatus = action.payload;
      })
      .addCase(forgetPassword.fulfilled, (state, action) => {
        state.forgetpwDetail = action.payload;
        state.forgetpwStatus = "loading";
      })
      .addCase(forgetPassword.pending, (state, action) => {
        state.forgetpwStatus = "pending";
      })
      .addCase(forgetPassword.rejected, (state, action) => {
        state.forgetpwStatus = "loading";
      })
      .addCase(verifyOTP.fulfilled, (state, action) => {
        state.verifyDetail = action.payload;
        state.verifyStatus = "fulfilled";
      })
      .addCase(verifyOTP.pending, (state, action) => {
        state.verifyStatus = "pending";
      })
      .addCase(verifyOTP.rejected, (state, action) => {
        state.verifyStatus = "loading";
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.resetDetail = action.payload;
        state.resetStatus = "loading";
      })
      .addCase(resetPassword.pending, (state, action) => {
        state.resetStatus = "pending";
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.resetStatus = "loading";
      })
      .addCase(getEarning.fulfilled, (state, action) => {
        state.earning = action.payload;
      })
      .addCase(getEarning.rejected, (state, action) => {
        state.earning = "";
      })
      .addCase(fetchWithdrawls.fulfilled, (state, action) => {
        state.withdrawRequest = action.payload;
      })
      .addCase(fetchWithdrawls.rejected, (state, action) => {
        state.withdrawRequest = "";
      })
      .addCase(bankWithdraw.fulfilled, (state, action) => {
        state.withdraw = action.payload;
      })
      .addCase(bankWithdraw.rejected, (state, action) => {
        state.withdraw = action.payload;
      })
      .addCase(getGpsPayment.fulfilled, (state, action) => {
        state.gpsPayment = action.payload;
      })
      .addCase(resendOTP.fulfilled, (state, action) => {
        state.resentOtpResp = action.payload;
      });
  },
});

export const {
  Logout,
  cleanupreset,
  cleanupVerifyNotif,
  cleanUp,
  cleanFPdetail,
  storeFPmail,
  storeSocialData,
  storeLoginId,
  cleanupOtp,
  cleanLogin,
  cleanupLoginNotif,
  cleanupSignupNotif,
  storeEmail,
  cleanwithdraw,
  clearEditProfile,
  cleanResentOtp,
} = authSlice.actions;
export default authSlice.reducer;
